<template>
  <v-breadcrumbs
    :items="items"
    divider="›"
  >
    <!-- Customize how each crumb is rendered -->
    <template #title="{ item }">
      <RouterLink
        v-if="item.to && !item.disabled"
        :to="item.to"
        class="crumb-link"
      >
        {{ item.title }}
      </RouterLink>
      <span
        v-else
        class="crumb-current"
      >{{ item.title }}</span>
    </template>
  </v-breadcrumbs>
</template>

<script>
export default {
  name: 'BreadCrumb',
  computed: {
    items() {
      const raw =
        typeof this.$route.meta?.breadCrumb === 'function'
          ? this.$route.meta.breadCrumb(this.$route)
          : (this.$route.meta?.breadCrumb || []);

      // Map v2-style { text, to, disabled } -> v3 expects { title, to, disabled }
      return raw.map(({ text, ...rest }) => ({
        title: text,
        ...rest,
      }));
    },
  },
};
</script>

<style>
/* Keep your white text look when inside the primary app bar */
.crumb-link {
  color: white;
  text-decoration: none;
}
.crumb-link:focus {
  outline: 2px solid white;
}
.crumb-current {
  color: white;
  font-size: large;
}
</style>
